import { render, staticRenderFns } from "./Satisfactions.vue?vue&type=template&id=2070e62a&"
import script from "./Satisfactions.vue?vue&type=script&lang=js&"
export * from "./Satisfactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports